import { FC, HTMLAttributes, PropsWithChildren } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

interface IStylesLabelTag extends HTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const StyledLabel = styled.label.attrs<IStyledAttributes>({
  "data-e2e": "form-label-ordinary",
})`
  font-size: 12px;
  color: ${greyMui._700};
`;

const StyledAsterisk = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "asterisk-ordinary",
})`
  font-size: 12px;
  color: #ff0000;
`;

const StyledHr = styled.hr.attrs<IStyledAttributes>({
  "data-e2e": "hr-ordinary",
})`
  border-top: 2px solid ${rydeColors.softGray};
  margin: 40px 0 30px;
`;

export const Label: FC<PropsWithChildren<IStylesLabelTag>> = props => {
  return (
    <StyledLabel>
      {props.children}
      {!!props.required && <StyledAsterisk>*</StyledAsterisk>}
    </StyledLabel>
  );
};

export const HR: FC<HTMLAttributes<HTMLHRElement>> = props => {
  return <StyledHr {...props} />;
};
